// src/pages/Sports.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useData } from "../context/DataProvider";

const Sports = () => {
   const { articles, loading } = useData();

   if (loading) {
      return <div className="p-8">Жүктелуде...</div>;
   }

   // Фильтруем статьи, где CategoryID = "3" (Спорт)
   const sportsArticles = articles.filter((article) => article.CategoryID === "3");

   return (
      <div>
         {/* Шапка (Hero) */}
         <header className="relative bg-gray-900 text-white py-12 px-4 sm:px-6 lg:px-8 mb-8">
            <div
               className="absolute inset-0 bg-cover bg-center opacity-60"
               style={{
                  backgroundImage:
                     "url('https://images.unsplash.com/photo-1591204940816-7dc24263705f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8c3BvcnRzJTIwc3RhdGl1bXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=1400&q=60')",
               }}
            />
            <div className="relative max-w-5xl mx-auto">
               <h1 className="text-4xl sm:text-5xl font-bold mb-2">Спорт</h1>
               <p className="text-lg text-gray-200 max-w-2xl">
                  Жергілікті және әлемдік спорт жарыстары, турнирлер және атлеттердің жетістіктері жайлы ақпаратты осында таба
                  аласыздар. Спорт әлемінің тынысын бірге бақылайық!
               </p>
            </div>
         </header>

         {/* Негізгі контент */}
         <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <section className="mb-8">
               <h2 className="text-2xl font-bold mb-4">Қош келдіңіздер!</h2>
               <p className="mb-4">
                  Бұл бөлімде сіздер футболдан бастап көкпарға дейінгі әр түрлі спорт түрлері туралы соңғы жаңалықтар мен
                  мәліметтерді таба аласыздар. Жергілікті спортшылардың жетістіктері мен халықаралық ареналардағы ел намысын
                  қорғап жүрген атлеттер туралы ең қызықты ақпараттарды назарларыңызға ұсынамыз.
               </p>
               <p>
                  Спорт тек денсаулық қана емес, рухты көтеретін, достық пен ынтымақтастықты арттыратын маңызды сала. Осы жерден
                  сіздер жаттығу кеңестері, сарапшылардың пікірлері және алдағы жарыстардың кестесі сияқты көптеген пайдалы
                  деректерді таба аласыздар.
               </p>
            </section>

            {/* Сетка новостей (ID=3) */}
            <section>
               <h2 className="text-xl font-bold mb-4">Спорт жаңалықтары</h2>

               {sportsArticles.length === 0 ? (
                  <p>Спорт санатында жаңалықтар жоқ</p>
               ) : (
                  <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                     {sportsArticles.map((article) => (
                        <SportsCard key={article.ID} article={article} />
                     ))}
                  </div>
               )}
            </section>
         </main>
      </div>
   );
};

/* Карточка одной новости */
function SportsCard({ article }) {
   const { ID, Title, Category, Date, ImageUrl } = article;

   return (
      <article className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
         <img
            src={ImageUrl || "https://via.placeholder.com/400x300"}
            alt={Title}
            className="w-full h-48 object-cover rounded-t-lg"
         />
         <div className="p-4">
            <p className="text-xs text-gray-500 mb-1">
               {Category} &mdash; {Date}
            </p>
            <h3 className="text-base font-semibold text-gray-800 mb-2 line-clamp-2">{Title}</h3>
            <Link to={`/news/${ID}`} className="text-sm text-blue-600 hover:underline">
               Толықтай оқу
            </Link>
         </div>
      </article>
   );
}

export default Sports;
